module.exports = __webpack_public_path__ + "media/src/LessonSchoolItemSearch/images/line_icon/clock-d14be1a0ca81d3a90850ca4e26f93604.svg";